import { FC, useContext } from "react";
import Link from "next/link";
import { Trans } from "@lingui/macro";
import { AppCtx } from "src/contexts/app.context";
import { Button } from "src/atoms/Button";
import { IButtonVariants } from "@otrium/atoms";

const ButtonCheckout: FC<{
  dataTestid: string;
  disabled: boolean;
  onClick?: () => void;
  variant?: keyof IButtonVariants;
}> = ({ dataTestid, disabled, onClick, variant = "primary" }): JSX.Element => {
  const { cartMinLineItemsTotalPriceDiff } = useContext(AppCtx);

  return cartMinLineItemsTotalPriceDiff?.centAmount > 0 ? (
    <Button
      data-testid={dataTestid}
      variant={variant}
      fullWidth
      onClick={onClick}
    >
      <Trans>Continue to checkout</Trans>
    </Button>
  ) : (
    <Link href="/checkout" passHref legacyBehavior>
      <Button
        disabled={disabled}
        role="link"
        data-testid={dataTestid}
        variant={variant}
        fullWidth
      >
        <Trans>Continue to checkout</Trans>
      </Button>
    </Link>
  );
};

export { ButtonCheckout };
